import admin from "%store/modules/admin";
import global from "%store/modules/global";
import home from "%store/modules/home";
import videos from "%store/modules/videos";
import video from "%store/modules/video";
import meta from "%store/modules/meta";
import security from "%store/modules/security";
import content from "%store/modules/content";
import messages from "%store/modules/messages";
import program from "%store/modules/program";
import statistics from "%store/modules/statistics";
import events from "%store/modules/events";
import users from "%store/modules/users";
import diagnostics from "%store/modules/diagnostics";

export default {
  admin,
  global,
  home,
  videos,
  video,
  meta,
  security,
  content,
  messages,
  program,
  statistics,
  events,
  users,
  diagnostics

  // modules will be imported here
};
